/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'ru'],
    localeDetection: false,
  },
  defaultNS: 'translation',
  debug: process.env.NODE_ENV === 'development',
  fallbackLng: 'ru',
  serializeConfig: false,
};
